var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9998,
    cy: 20,
    r: 19.5,
    fill: "#F8EEDF",
    stroke: "#E9E0D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6664 21.7778L22.5624 21.784C22.364 21.8074 22.1793 21.897 22.038 22.0382C21.8967 22.1795 21.8072 22.3643 21.7838 22.5627L21.7775 22.6667V28H12.8869C12.6522 28.0005 12.427 27.9078 12.2606 27.7423C12.0943 27.5768 12.0005 27.352 11.9998 27.1173V12.8827C11.9998 12.3956 12.3953 12 12.8824 12H27.1171C27.6042 12 27.9998 12.3973 27.9998 12.888V21.7778H22.6664ZM27.9998 23.5556L23.5553 27.9973V23.5556H27.9998Z",
    fill: "#B17F34"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.d0c6a8d5a45d863e55070651b5a84c9c.svg";
export { ForwardRef as ReactComponent };